import {
    CREATE_PRODUCT_FAILURE,
    CREATE_PRODUCT_LOGO_SUCCESS,
    CREATE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILURE,
    DELETE_PRODUCT_LOGO_SUCCESS,
    DELETE_PRODUCT_SUCCESS,
    FETCH_PRODUCT,
    FETCH_PRODUCTS,
    FETCH_PRODUCTS_FAILURE,
    FETCH_PRODUCTS_SUCCESS,
    FETCH_PRODUCT_FAILURE,
    FETCH_PRODUCT_SUCCESS,
    PRODUCTS_LIST_FILTER_UPDATE,
    PRODUCTS_LIST_FILTER_CATEGORY,
    PRODUCTS_LIST_PAGE,
    PRODUCTS_LIST_SORT,
    SAVE_PRODUCT_CONFIGURATON,
    SAVE_PRODUCT_CONFIGURATON_FAILURE,
    SAVE_PRODUCT_CONFIGURATON_SUCCESS,
    SORT_ASC,
    UPDATE_PRODUCT,
    UPDATE_PRODUCT_ACTIVITY_SUCCESS,
    UPDATE_PRODUCT_LOCATION,
    UPDATE_PRODUCT_LOCATION_FAILURE,
    UPDATE_PRODUCT_LOCATION_SUCCESS,
    UPDATE_PRODUCT_RESOURCE,
    UPDATE_PRODUCT_RESOURCE_FAILURE,
    UPDATE_PRODUCT_RESOURCE_SUCCESS,
    UPDATE_PRODUCT_SUCCESS,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'title',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCT:
        case FETCH_PRODUCTS:
        case UPDATE_PRODUCT:
        case UPDATE_PRODUCT_LOCATION:
        case UPDATE_PRODUCT_RESOURCE:
        case SAVE_PRODUCT_CONFIGURATON:
            return Object.assign({}, state, {
                loading: true,
            });

        case CREATE_PRODUCT_FAILURE:
        case DELETE_PRODUCT_FAILURE:
        case FETCH_PRODUCTS_FAILURE:
        case FETCH_PRODUCT_FAILURE:
        case UPDATE_PRODUCT_LOCATION_FAILURE:
        case UPDATE_PRODUCT_RESOURCE_FAILURE:
        case SAVE_PRODUCT_CONFIGURATON_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_PRODUCTS_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case FETCH_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    action.response.id,
                ],
                loading: false,
            });

        case CREATE_PRODUCT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.id]: action.response,
                }),
                loading: false,
            });

        case CREATE_PRODUCT_LOGO_SUCCESS:
            const addProductLogo = Object.assign(
                {},
                state.data[action.productId],
                {
                    logo: action.response.url,
                }
            );

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.productId]: addProductLogo,
                }),
            });

        case DELETE_PRODUCT_LOGO_SUCCESS:
            if (!action.id) {
                return state;
            }

            const newObjectAfterDelete = Object.assign({},
                state.data[action.id],
                {
                    logo: null,
                },
            );

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.id]: newObjectAfterDelete,
                }),
            });

        case UPDATE_PRODUCT_ACTIVITY_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                loading: false,
            });

        case UPDATE_PRODUCT_SUCCESS:
        case UPDATE_PRODUCT_LOCATION_SUCCESS:
        case UPDATE_PRODUCT_RESOURCE_SUCCESS:
        case SAVE_PRODUCT_CONFIGURATON_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: action.response,
                }),
                loading: false,
            });

        case DELETE_PRODUCT_SUCCESS:
            const { id } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id.toString());

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                total: state.total - 1,
            });

        case PRODUCTS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case PRODUCTS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case PRODUCTS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case PRODUCTS_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/productsReducer.js